import { userActionTypes } from "../constants/action-types"

const initialUserState = {
  error: "",
  eAuthToken: null,
}

const userReducer = (state = initialUserState, action) => {
  switch (action.type) {
    case userActionTypes.LOGIN_REQUEST:
      return { ...state }

    case userActionTypes.LOGIN_SUCCESS:
      sessionStorage.setItem("token", action.payload)
      localStorage.setItem("Auth", true)
      return {
        ...state,
        eAuthToken: action.payload,
        error: "",
      }

    case userActionTypes.LOGIN_FAILURE:
      return {
        ...state,
        eAuthToken: "",
        error: action.payload,
      }
    case userActionTypes.LOGOUT_USER:
      localStorage.removeItem("Auth")
      sessionStorage.removeItem("token")
      return {
        ...state,

        eAuthToken: null,
        error: "",
      }

    // case userActionTypes.SET_USER_NAME:
    //   return {
    //     ...state,
    //     name: action.payload
    //   }

    default:
      return state
  }
}

export default userReducer
